module.exports = __webpack_public_path__ + "media/images/content-ad709e1db70622410c0bed69dd4e9ada.jpg";